module.exports = __webpack_public_path__ + "static/assets/0b09fe426a0a8dec90cedaf030040d4f.png";